export default __webpack_public_path__ + "static/media/marker-pickup-map.67c4409a.svg";